<main class="hold-card">
  <!-- HEADER BAND -->
  <div class="hold-head">
    <div class="hold-badge">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-[31px]" aria-hidden="true">
        <path d="M12 2v4" />
        <path d="m16.24 7.76 2.83-2.83" />
        <path d="M18 12h4" />
        <path d="m16.24 16.24 2.83 2.83" />
        <path d="M12 18v4" />
        <path d="m7.76 16.24-2.83 2.83" />
        <path d="M2 12h4" />
        <path d="m7.76 7.76-2.83-2.83" />
      </svg>
    </div>
    <span class="hold-eyebrow">
      <span class="pulse" aria-hidden="true"></span>Subscription needed
    </span>
    <h1 class="hold-title use-grotesque">Pick a plan to keep going, {{ firstName() }}.</h1>
  </div>

  <!-- BODY -->
  <div class="p-8">
    <p class="mb-6 font-sans text-[16px] font-medium leading-[1.5] text-[var(--foreground)]">
      Your account doesn't have an active subscription. To keep posting briefs, hiring creators and
      managing your campaigns, choose a plan below — it only takes a minute and you'll be straight
      back in.
    </p>

    <!-- REASSURANCE -->
    <div class="mb-6 flex items-start gap-[11px] rounded-lg border border-[#0B8F4E]/[0.18] bg-[#0B8F4E]/[0.07] px-4 py-[14px]">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="mt-px size-[19px] shrink-0 text-[#0B8F4E]" aria-hidden="true">
        <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
        <path d="m9 12 2 2 4-4" />
      </svg>
      <p class="m-0 font-sans text-[13.5px] font-medium leading-[1.45] text-[var(--foreground)]">
        <b class="font-bold">Your data is safe.</b> Briefs, creators and content stay exactly as you left
        them — subscribing simply switches your access back on.
      </p>
    </div>

    <!-- ACTIONS -->
    <div class="flex flex-col gap-3 sm:flex-row">
      <button type="button" class="hold-btn hold-btn-primary" (click)="choosePlan()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M5 12h14" />
          <path d="m12 5 7 7-7 7" />
        </svg>
        Choose a plan
      </button>
      <button type="button" class="hold-btn hold-btn-outline" [disabled]="checking()" (click)="alreadySubscribed()">
        @if (checking()) {
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="hold-spin" aria-hidden="true">
            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
          </svg>
          Checking…
        } @else {
          I've already subscribed
        }
      </button>
    </div>

    @if (actionError()) {
      <p class="mt-3 font-sans text-[13px] font-semibold text-[#DC2626]" role="alert">{{ actionError() }}</p>
    }

    <!-- FOOT -->
    <div class="mt-6 flex items-center justify-between border-t border-[var(--border)] pt-5 font-sans text-[13px] font-medium text-[var(--muted-foreground)]">
      <p class="m-0">Questions about your account?</p>
      <a class="inline-flex items-center gap-[5px] font-bold text-[var(--brand-purple)]"
        [href]="'mailto:' + supportEmail">
        Contact billing support
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-[14px]" aria-hidden="true">
          <path d="M5 12h14" />
          <path d="m12 5 7 7-7 7" />
        </svg>
      </a>
    </div>
  </div>
</main>
